const videoElements = document.querySelectorAll('.video');

videoElements.forEach((videoEl) => {
    const playButton = videoEl.querySelector('.video__play-button');
    const previewImage = videoEl.querySelector('.video__preview');
    const wrapper = videoEl.querySelector('.video__video');

    if (wrapper) {
        const videoId = wrapper.dataset.videoId;
        if (playButton) {
            playButton.addEventListener('click', () => {
                if (previewImage && wrapper && videoId) {
                    wrapper.innerHTML = `
                        <iframe
                            src='https://www.youtube.com/embed/${videoId}?autoplay=1'
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>`;
                    playButton.style.display = 'none';
                    previewImage.style.display = 'none';
                }
            });
        } else {
            if (wrapper && videoId) {
                wrapper.innerHTML = `
                    <iframe
                        src='https://www.youtube.com/embed/${videoId}'
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    ></iframe>
                `;
            }
        }
    }
});
